import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h6", { class: "q-ma-none" }, "Redigera avställning", -1)
const _hoisted_2 = {
  key: 0,
  class: "text-negative text-caption text-weight-bold row items-center col q-mr-sm"
}
const _hoisted_3 = {
  key: 1,
  class: "col"
}
const _hoisted_4 = { class: "row items-center q-gutter-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_VehicleWithdrawalForm = _resolveComponent("VehicleWithdrawalForm")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    "model-value": true,
    onHide: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        square: "",
        style: {"width":"500px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_form, {
            ref: "formRef",
            onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"]),
            autocomplete: "off",
            greedy: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_q_separator),
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createVNode(_component_VehicleWithdrawalForm, _mergeProps({ ref: "vehicleFormRef" }, _ctx.$props, {
                    modelValue: _ctx.model,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model) = $event)),
                    "form-type": "update",
                    onDisable: _cache[1] || (_cache[1] = (val) => (_ctx.disableForm = val)),
                    onWarning: _cache[2] || (_cache[2] = (msg) => (_ctx.vehicleWarningText = msg))
                  }), null, 16, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_q_separator),
              _createVNode(_component_q_card_actions, { class: "row items-center justify-between q-px-md q-py-sm" }, {
                default: _withCtx(() => [
                  (_ctx.vehicleWarningText)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_q_icon, {
                          name: "mdi-alert-circle-outline",
                          class: "q-mr-xs",
                          size: "18px"
                        }),
                        _createElementVNode("span", null, _toDisplayString(_ctx.vehicleWarningText), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_3)),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_q_btn, {
                      flat: "",
                      label: "Avbryt",
                      onClick: _ctx.closeModal,
                      disable: _ctx.pending
                    }, null, 8, ["onClick", "disable"]),
                    _createVNode(_component_q_btn, {
                      label: "Uppdatera",
                      color: "white",
                      class: "text-red",
                      type: "submit",
                      loading: _ctx.pending,
                      disable: _ctx.disableForm
                    }, null, 8, ["loading", "disable"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onHide"]))
}